import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";

import { FormikTextareaField } from "components/InputsField/formikInputs/FormikTextareaField";
import FormikTextField from "components/InputsField/formikInputs/FormikTextField";
import FormRow from "components/common/Layout/FormRow";
import ShadowBlock from "components/common/Layout/ShadowBlock";
import { getCompanyInfo } from "store/company";

import styles from "./styles.module.scss";

export default function AddCompanyInfo({ additionalFields }) {
    const dispatch = useDispatch();
    const profile = useSelector((state) => state.profile.profileData);
    const company = useSelector((state) => state.company.companyData);
    const lang = useSelector((state) => state.settings.lang);

    const loadData = useCallback(() => {
        dispatch(
            getCompanyInfo({
                id: profile.company_id,
                lang,
            }),
        );
    }, [dispatch, profile.company_id, lang]);

    useEffect(() => {
        if (Object.keys(company).length === 0 && profile.id) {
            loadData();
        }
    }, [loadData, company, profile.id]);

    const { t } = useTranslation();

    return (
        <ShadowBlock>
            <FormRow>
                <div>
                    <FormikTextField
                        name="organization_name"
                        label={t("company.company_name")}
                        value={company.name}
                        disabled
                    />
                    {additionalFields && additionalFields}
                </div>
                {profile && profile.picture && (
                    <div className={styles["company__logo-container"]}>
                        <img
                            className={styles.company__logo}
                            src={profile.picture}
                            alt={(profile && profile.organization_name) || ""}
                        />
                    </div>
                )}
            </FormRow>

            <FormRow withMargin>
                <FormikTextareaField
                    name="notes"
                    label={t("addContact.notes")}
                    rows="5"
                    maxLength="4096"
                    placeholder={t("addContact.notes_grey")}
                />
            </FormRow>
        </ShadowBlock>
    );
}
